import { PAGINATION_BUTTON_VARIANT } from "./types";

export const paginationButonClass = {
  [PAGINATION_BUTTON_VARIANT.ARROW]: {
    class:
      "h-8   w-8   fds-sm:h-10 fds-sm:w-10 text-fds-icon-secondary disabled:text-fds-disable",
    icon: "fds-sm:h-6  fds-sm:w-6  h-5    w-5",
  },
  [PAGINATION_BUTTON_VARIANT.TEXT]: {
    class:
      "fds-sm:h-10 fds-sm:px-2  h-8   px-1.5  text-fds-brand hover:text-fds-brand-hover disabled:text-fds-disable",
    icon: "fds-sm:h-6  fds-sm:w-6  h-6  w-6",
  },
};
